(function () {
  var BREAKPOINTS = [
    { maxWidth: 599, slidesPerGroup: 1 },   // mobile
    { maxWidth: 989, slidesPerGroup: 2 },   // tablet
    { maxWidth: Infinity, slidesPerGroup: 3 } // desktop
  ];

  function getSlidesPerGroup() {
    var width = window.innerWidth;
    for (var i = 0; i < BREAKPOINTS.length; i++) {
      if (width <= BREAKPOINTS[i].maxWidth) return BREAKPOINTS[i].slidesPerGroup;
    }
    return 3;
  }

  function setupDots(track, dotsEl) {
    var slides = Array.prototype.slice.call(track.querySelectorAll('.testimonials__slide'));
    var slidesPerGroup = getSlidesPerGroup();
    var groupCount = Math.ceil(slides.length / slidesPerGroup);
    dotsEl.innerHTML = '';

    for (var g = 0; g < groupCount; g++) {
      (function (groupIndex) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'testimonials__dot' + (groupIndex === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide group ' + (groupIndex + 1));
        dot.addEventListener('click', function () {
          var targetSlide = slides[groupIndex * slidesPerGroup];
          if (targetSlide) {
            targetSlide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          }
        });
        dotsEl.appendChild(dot);
      })(g);
    }

    if (!('IntersectionObserver' in window)) return null;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var index = slides.indexOf(entry.target);
          var groupIndex = Math.floor(index / slidesPerGroup);
          dotsEl.querySelectorAll('.testimonials__dot').forEach(function (d, i) {
            d.classList.toggle('is-active', i === groupIndex);
          });
        });
      },
      { root: track, threshold: 0.6 }
    );
    slides.forEach(function (s) { observer.observe(s); });
    return observer;
  }

  function initSection(section) {
    var track = section.querySelector('[data-testimonials-track]');
    var dotsEl = section.querySelector('[data-testimonials-dots]');
    if (!track || !dotsEl) return;

    var currentObserver = setupDots(track, dotsEl);
    var currentSlidesPerGroup = getSlidesPerGroup();

    // Rebuild dots if the viewport crosses a breakpoint (resize, rotate)
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var newSlidesPerGroup = getSlidesPerGroup();
        if (newSlidesPerGroup !== currentSlidesPerGroup) {
          if (currentObserver) currentObserver.disconnect();
          currentSlidesPerGroup = newSlidesPerGroup;
          currentObserver = setupDots(track, dotsEl);
        }
      }, 150);
    });
  }

  document.querySelectorAll('[data-testimonials]').forEach(initSection);
})();